import {Link} from 'react-router-dom';
import {useTodoMutations, useTodos} from '../../api/todos';
import Icon from '../Icon';
import {dueLabel} from '../../lib/todos';
import {useTellIt} from './useTellIt';

// The Journal's Due band (DESIGN.md §5): to-dos due today or overdue, on the marigold card with
// a round Mark done. Only real to-dos; the suggestions wait on the To do tab.
const SHOW = 3;

export default function DueBand() {
    const todos = useTodos();
    const {done} = useTodoMutations();
    const tellIt = useTellIt();
    const today = todos.data?.today;
    const due = today ? (todos.data?.open ?? []).filter(t => t.dueLocal !== null && t.dueLocal <= today) : [];
    if (!today || due.length === 0) return null;

    return (
        <section className="flex flex-col gap-2" aria-label="Due">
            <h2 className="band-label m-0 text-marigold-text">Due today</h2>
            <div className="rows rounded-[18px] bg-marigold-soft">
                {due.slice(0, SHOW).map(todo => (
                    <div key={todo.id} className="flex min-h-[64px] items-center gap-3 px-3 py-2">
                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[12px] bg-marigold text-on-marigold">
                            <Icon name="reminder" size={22} />
                        </span>
                        <Link to={`/todo/${todo.id}`} className="min-w-0 flex-1 no-underline">
                            <span className="block truncate font-semibold text-ink">{todo.title || 'To do'}</span>
                            <span className="meta block truncate">{[dueLabel(todo.dueLocal, today), todo.plants[0]?.label, todo.place?.name].filter(Boolean).join(' · ')}</span>
                        </Link>
                        <button
                            type="button"
                            aria-label={`Mark done: ${todo.title}`}
                            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-pill border-[1.5px] border-marigold-text text-marigold-text"
                            onClick={() => done.mutate(todo.id, {onSuccess: post => tellIt(todo, post.doneAt === null)})}
                        >
                            <Icon name="check" size={20} strokeWidth={2.2} />
                        </button>
                    </div>
                ))}
            </div>
            {due.length > SHOW && (
                <Link to="/todo" className="meta self-start font-semibold text-marigold-text no-underline">
                    and {due.length - SHOW} more on To do
                </Link>
            )}
        </section>
    );
}
